import { useEffect, useRef } from 'react';
import { ButtonLoading, AutocompleteV, Icons } from 'components';
import { useForm } from 'react-hook-form';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Grid,
  FormLabel,
  Checkbox,
} from '@mui/material';
import useCustomHook from './hooks';
import { useStylesAddDealerDialog } from './style';
import { Alert } from '@mui/material';
import { useBusinessList } from 'hooks';
import _ from 'lodash';
import createToast from 'components/Toast/Toast';

import DealerService from '../services';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';

export default function AddDealerDialog({ open, setOpen, tableRef }) {
  const { formState: { errors }, control, getValues, handleSubmit, register, setError } = useForm();
  const { getBusinessList, busibessList, businessLoading } = useBusinessList();
  const classes = useStylesAddDealerDialog();
  const onCheckBoxChange = (ev) => {
    ev.persist();
    setAllProductAllow(ev.target.checked);
  };
  const {
    loading,
    setLoading,
    allProductAllow,
    setAllProductAllow,
    businessSearchText,
    setBusinessSearchText,
  } = useCustomHook();
  useEffect(() => {
    setAllProductAllow(true);
  }, [open]);

  const delayedQuery = useRef(_.debounce((v, f) => f(v), 500)).current;
  useEffect(() => {
    delayedQuery(businessSearchText, getBusinessList);
  }, [businessSearchText]);

  const addDealerDialog = async () => {
    const data = getValues();
    if (!data.business) {
      setError('business', { message: 'فیلد کسب‌وکار اجباری است' });
    } else {
      try {
        setLoading(true);

        await DealerService.addDealer({
          allProductAllow,
          dealerBizId: data.business?.id,
        });
        createToast('موفق', 'کسب‌وکار با موفقیت به لیست کارگزار ها افزوده شد', 'success');

        setTimeout(() => {
          tableRef?.current?.onChangeTable();
        }, 100);
      } catch (error) {
      } finally {
        setLoading(false);
        setOpen(false);
      }
    }
  };

  const onClose = () => setOpen(false);
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      maxWidth="sm"
      fullWidth
      open={open}
      className={classes.dialogMain}
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose} className={classes.title}>
        افزودن کارگزار
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <Icons icon='Close' color="#939393" size="20" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialog}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={12}>
            <AutocompleteV
              placeholder="جستجو و انتخاب کنید..."
              control={control}
              filterOptions={(options, state) => options}
              errors={errors}
              register={register}
              rules={['required']}
              name="business"
              label="کسب و کار"
              list={busibessList}
              preventAddCustomOption
              loading={businessLoading}
              getOptionSelected={(option, value) => option.id === value.id}
              onInputChange={(e) => {
                if (e?.target?.value === businessSearchText) return;
                setBusinessSearchText(e?.target?.value ?? '');
              }}
              disableClearable
            />
            {errors.business && (
              <span className={classes.errorMesssage}>{errors.business?.message}</span>
            )}
            <Grid item>
              <Checkbox
                name="allProductAllow"
                required
                color="primary"
                defaultChecked={allProductAllow}
                value={allProductAllow}
                onChange={onCheckBoxChange}
                icon={<CheckBoxIcon />}
                checkedIcon={<CheckBoxIconFill />}
              />
              <FormLabel>اجازه دسترسی به تمام محصولات داده می شود</FormLabel>
              {!allProductAllow && (
                <Alert severity="info">
                  می توانید از لیست محصولات دارای مجوز محصول موردنظر خود را به لیست اضافه کنید
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid md={12} xs={12} lg={12}
            style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px' }}
          >
            <ButtonLoading
              name="افزودن"
              loading={loading}
              variant="contained"
              color="primary"
              onClick={handleSubmit(addDealerDialog)}
              style={{ marginTop: '1em', marginRight: 'auto' }}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
